__turbopack_context__.v({
  "about": "styles-module-scss-module__r0AshG__about",
  "aboutClamped": "styles-module-scss-module__r0AshG__aboutClamped",
  "aboutColumn": "styles-module-scss-module__r0AshG__aboutColumn",
  "aboutLayout": "styles-module-scss-module__r0AshG__aboutLayout",
  "contactHeader": "styles-module-scss-module__r0AshG__contactHeader",
  "fact": "styles-module-scss-module__r0AshG__fact",
  "factChevron": "styles-module-scss-module__r0AshG__factChevron",
  "factCount": "styles-module-scss-module__r0AshG__factCount",
  "factGrid": "styles-module-scss-module__r0AshG__factGrid",
  "factIcon": "styles-module-scss-module__r0AshG__factIcon",
  "factLabel": "styles-module-scss-module__r0AshG__factLabel",
  "factList": "styles-module-scss-module__r0AshG__factList",
  "factSummary": "styles-module-scss-module__r0AshG__factSummary",
  "factSummaryIcon": "styles-module-scss-module__r0AshG__factSummaryIcon",
  "factSummaryItem": "styles-module-scss-module__r0AshG__factSummaryItem",
  "memberOf": "styles-module-scss-module__r0AshG__memberOf",
  "mission": "styles-module-scss-module__r0AshG__mission",
  "missionLabel": "styles-module-scss-module__r0AshG__missionLabel",
  "missionText": "styles-module-scss-module__r0AshG__missionText",
  "socials": "styles-module-scss-module__r0AshG__socials",
  "thumb": "styles-module-scss-module__r0AshG__thumb",
  "thumbStack": "styles-module-scss-module__r0AshG__thumbStack",
});
